import { createFileRoute } from '@tanstack/react-router';
import { NewBrandPage } from '@/features/brand-research/NewBrandPage';

export const Route = createFileRoute('/brands/new')({
  component: NewBrandPage,
});
